<template>
    <div class="categoriesMenuBlock">
        <div class="product-category-content-wrapper">
            <div class="row">
                <div class="col-lg-12 dis-flex mb-4 p-lr-0-sm element-forms-selecting desctop-options-menu">
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'permissionsGroups'" :class="{'active-btn': selectedMenu == 'permissionsGroups'}">
                        <i class="uis uis-square-shape mr-2"></i>Created Groups
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'usersGroups'" :class="{'active-btn': selectedMenu == 'usersGroups'}">
                        <i class="uis uis-user-square mr-2"></i>Give Access
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'createPermGroup'" :class="{'active-btn': selectedMenu == 'createPermGroup'}">
                        <i class="uis uis-sitemap mr-2"></i>Create group
                    </button>
                </div>
                <div class="col-lg-12 mb-4 p-lr-0-sm element-forms-selecting mobile-options-menu">
                    <button type="button" class="btn btn-element" attr="Created Groups" @click="selectedMenu = 'permissionsGroups'" :class="{'active-btn': selectedMenu == 'permissionsGroups'}">
                        <i class="uis uis-square-shape mr-2"></i>
                    </button>
                    <button type="button" class="btn btn-element" attr="Give Access" @click="selectedMenu = 'usersGroups'" :class="{'active-btn': selectedMenu == 'usersGroups'}">
                        <i class="uis uis-user-square mr-2"></i>
                    </button>
                    <button type="button" class="btn btn-element" attr="Create group" @click="selectedMenu = 'createPermGroup'" :class="{'active-btn': selectedMenu == 'createPermGroup'}">
                        <i class="uis uis-sitemap mr-2"></i>
                    </button>
                </div>
            </div>

            <permissions-groups v-if="selectedMenu == 'permissionsGroups'"
                :permissionsGroupsList="permissionsGroupsList"
                @getPermissionsGroups="getPermissionsGroups"
                :allPermissionsByGroup="allPermissionsByGroup"
                @setSelectedMenu="setSelectedMenu"></permissions-groups>
            <user-groups v-else-if="selectedMenu == 'usersGroups'"></user-groups>
            <create-group v-else-if="selectedMenu == 'createPermGroup'"
                :permissionsGroupsList="permissionsGroupsList"
                @getPermissionsGroups="getPermissionsGroups"></create-group>
        </div>
    </div>
</template>

<script>
import permissionsGroupsVue from './permissionsGroups/permissionsGroups.vue';
import userGroupsVue from './userGroups.vue';
import createGroupVue from './createGroup.vue';

export default {
    components: {
        permissionsGroups: permissionsGroupsVue,
        userGroups: userGroupsVue,
        createGroup: createGroupVue
    },
    data() {
        return {
            selectedMenu: 'permissionsGroups',
            permissionsGroupsList: {},
            allPermissionsByGroup: {},
            allPermissionsByGroupLoaded: false,
        }
    },
    mounted() {
        this.getPermissionsGroups();
        this.getAllPermissionsByGroup();

        this.permissionsGroupsList['1'] = {
            group_id: 1,
            group_name: 'Admin',
            group_description: '',
            group_permissions: {
                'admin.categories.category.create': {
                    description: 'Create categories',
                    value: 1
                },
                'admin.categories.subcategory.create':{
                    description: 'Create subCategories',
                    value: 1
                },
                'admin.categories.section.create': {
                    description: 'Create section',
                    value: 1
                }
            }
        }

        this.permissionsGroupsList['2'] = {
            group_id: 2,
            group_name: 'Moderator',
            group_description: 'Moderator group',
            group_permissions: {
                'admin.categories.category.create': {
                    description: 'Create categories',
                    value: 1
                },
                'admin.categories.subcategory.create':{
                    description: 'Create subCategories',
                    value: 1
                },
                'admin.categories.section.create': {
                    description: 'Create section',
                    value: 1
                }
            }
        }

        this.permissionsGroupsList['3'] = {
            group_id: 3,
            group_name: 'Secretary',
            group_description: '',
            group_permissions: {}
        }
    },
    methods: {
        setSelectedMenu(menu) {
            this.selectedMenu = menu;
        },
        getPermissionsGroups() {
            socket.emit('permissions:getPermissionsGroups', (data) => {
                // console.log(data)
                this.permissionsGroupsList = data.data
            });
        },
        getAllPermissionsByGroup() {
            socket.emit('permissions:getAllPermissions', (data) => {
                console.log(data)
                this.allPermissionsByGroup = data.data
                this.allPermissionsByGroupLoaded = true
            });
        }
    }
}
</script>

<style>

</style>